// Material Design 3 color system
// https://m3.material.io/styles/color/the-color-system/color-roles

export const colors = {
  light: {
    // Background colors
    background: {
      default: "#FAFAFA", // Surface
      paper: "#FFFFFF", // Surface
      sidebar: "#ffffff",
      table: "#ffffff",
      hover: "rgba(0, 0, 0, 0.04)",
      selected: "rgba(0, 0, 0, 0.08)",
      selectedHover: "rgba(0, 0, 0, 0.12)",
    },
    // Text colors
    text: {
      primary: "rgba(0, 0, 0, 0.87)", // On Surface
      secondary: "rgba(0, 0, 0, 0.6)", // On Surface Variant
      disabled: "rgba(0, 0, 0, 0.38)", // On Surface Variant
      hint: "rgba(0, 0, 0, 0.6)",
    },
    // Border colors
    border: {
      default: "rgba(0, 0, 0, 0.12)", // Outline
      divider: "rgba(0, 0, 0, 0.12)", // Outline Variant
    },
    // Brand colors
    brand: {
      primary: "#006494", // Primary
      primaryLight: "#4B9FCA", // Primary Container
      primaryDark: "#00466A", // On Primary Container
      secondary: "#2B5C73", // Secondary
    },
    // Status colors
    status: {
      success: "#2E7D32", // Success
      error: "#D32F2F", // Error
      warning: "#ED6C02", // Warning
      info: "#0288D1", // Info
      errorLight: "#FFEBEE", // Very light red for violations background
      warningLight: "#FFF3E0", // Very light orange for disconnected background
      errorMain: "#EF5350", // Softer red for violations
      warningMain: "#FFA726", // Softer orange for disconnected
    },
    // Vehicle status colors
    vehicle: {
      moving: "#4CAF50",
      stopped: "#F44336",
      idle: "#FFC107",
      default: "#2196F3",
    },
  },
  dark: {
    // Background colors
    background: {
      default: "#121212", // Surface
      paper: "#1E1E1E", // Surface Container Low
      sidebar: "#1e1e1e",
      table: "#1e1e1e",
      hover: "rgba(255, 255, 255, 0.05)",
      selected: "rgba(255, 255, 255, 0.08)",
      selectedHover: "rgba(255, 255, 255, 0.12)",
    },
    // Text colors
    text: {
      primary: "#FFFFFF", // On Surface
      secondary: "rgba(255, 255, 255, 0.7)", // On Surface Variant
      disabled: "rgba(255, 255, 255, 0.5)", // On Surface Variant
      hint: "rgba(255, 255, 255, 0.6)",
    },
    // Border colors
    border: {
      default: "rgba(255, 255, 255, 0.12)", // Outline
      divider: "rgba(255, 255, 255, 0.12)", // Outline Variant
    },
    // Brand colors
    brand: {
      primary: "#4B9FCA", // Primary Container
      primaryLight: "#73B8DB", // Primary
      primaryDark: "#00466A", // On Primary Container
      secondary: "#4B9FCA", // Secondary Container
    },
    // Status colors
    status: {
      success: "#66BB6A", // Success Container
      error: "#F44336", // Error Container
      warning: "#FFA726", // Warning Container
      info: "#29B6F6", // Info Container
      errorLight: "#311B1B", // Dark soft red for violations background
      warningLight: "#2E1F0F", // Dark soft orange for disconnected background
      errorMain: "#CF6679", // Softer red for violations in dark mode
      warningMain: "#FFB74D", // Softer orange for disconnected in dark mode
    },
    // Vehicle status colors
    vehicle: {
      moving: "#4CAF50",
      stopped: "#F44336",
      idle: "#FFC107",
      default: "#2196F3",
    },
  },
};
